'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.typed-array.to-reversed');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.typed-array.to-reversed.js
// module id = 482
// module chunks = 31